require.config({map: {
	"jquery.cookie": {
		"jquery": "jQuery"
	}
}});
define("shopping", function(){});

